import createInformesSectionPage from "./SectionPageFactory";

const InformesFinanzasPage = createInformesSectionPage(
  "Finanzas",
  "Consultá indicadores de flujo de caja, ingresos, egresos y variaciones presupuestarias."
);

export default InformesFinanzasPage;
